type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const BankIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.3031 26.2588C23.3931 26.2588 21.5614 27.0175 20.2108 28.3681C18.8603 29.7186 18.1016 31.5504 18.1016 33.4603C18.1016 35.3703 18.8603 37.202 20.2108 38.5526C21.5614 39.9031 23.3931 40.6618 25.3031 40.6618C27.2131 40.6618 29.0448 39.9031 30.3953 38.5526C31.7459 37.202 32.5046 35.3703 32.5046 33.4603C32.5046 31.5504 31.7459 29.7186 30.3953 28.3681C29.0448 27.0175 27.2131 26.2588 25.3031 26.2588ZM22.2167 33.4603C22.2167 32.6418 22.5419 31.8567 23.1207 31.2779C23.6995 30.6991 24.4845 30.3739 25.3031 30.3739C26.1216 30.3739 26.9067 30.6991 27.4855 31.2779C28.0643 31.8567 28.3895 32.6418 28.3895 33.4603C28.3895 34.2789 28.0643 35.0639 27.4855 35.6427C26.9067 36.2215 26.1216 36.5467 25.3031 36.5467C24.4845 36.5467 23.6995 36.2215 23.1207 35.6427C22.5419 35.0639 22.2167 34.2789 22.2167 33.4603Z"
        fill={color}
      />
      <path
        d="M36.674 11.064L30.1329 1.89337L6.0819 21.107L4.74858 21.0926V21.1132H3.69922V45.8042H46.9084V21.1132H44.929L40.9908 9.59283L36.674 11.064ZM40.5813 21.1132H19.9479L35.316 15.8746L38.4476 14.8726L40.5813 21.1132ZM32.6082 12.4508L16.7443 17.8581L29.3079 7.82126L32.6082 12.4508ZM7.81438 37.9216V28.9917C8.68246 28.6841 9.47095 28.1866 10.1224 27.5356C10.7738 26.8845 11.2717 26.0963 11.5797 25.2284H39.0279C39.3358 26.0966 39.8336 26.8852 40.485 27.5366C41.1364 28.188 41.925 28.6858 42.7932 28.9937V37.9236C41.925 38.2316 41.1364 38.7294 40.485 39.3808C39.8336 40.0322 39.3358 40.8208 39.0279 41.689H11.5839C11.2756 40.8201 10.7772 40.0309 10.1251 39.3791C9.47294 38.7273 8.6835 38.2294 7.81438 37.9216Z"
        fill={color}
      />
    </svg>
  );
};
